const storagePrefix = "mj_siteops_";

const storage = {
  /**
   * Removes the access tokens earlier builds mirrored here. MSAL owns the token
   * cache now (see `utils/auth.ts`) — this only evicts stale copies left in
   * browsers that ran a previous build.
   */
  clearLegacyTokens: () => {
    window.localStorage.removeItem(`${storagePrefix}token`);
    window.localStorage.removeItem(`${storagePrefix}bff_token`);
  },
  getProject: () => {
    return window.localStorage.getItem(`${storagePrefix}project`);
  },
  setProject: (projectName: string) => {
    window.localStorage.setItem(`${storagePrefix}project`, projectName);
  },
  clearProject: () => {
    window.localStorage.removeItem(`${storagePrefix}project`);
  }
};

export default storage;
